import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bs-search-form',
  templateUrl: './search-form.component.html',
  styleUrls: ['./search-form.component.css']
})
export class SearchFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
